// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import lissueEntity from './entities/lissue.json';
import lissueMenu from '../pages/lissue/menu.json';
import lissueFullForm from '../pages/lissue/forms/full.json';
import lissueContextForm from '../pages/lissue/forms/context.json';
import lissueMiniForm from '../pages/lissue/forms/mini.json';
import lissueLookupForm from '../pages/lissue/forms/lookup.json';
import lissueTableView from '../pages/lissue/views/table.json';
import lissueStagesView from '../pages/lissue/views/stages.json';
import lissueCardsView from '../pages/lissue/views/cards.json';
import lissueInlineView from '../pages/lissue/views/inline.json';
import lissueBacklogView from '../pages/lissue/views/backlog.json';
import lissueSplitView from '../pages/lissue/views/split.json';
import lissueCalendarView from '../pages/lissue/views/calendar.json';
import lissueDashboardView from '../pages/lissue/views/dashboard.json';

/** Тип запису «Правове питання» зі сторінками пакета: меню, форми та подання з pages/lissue/. */
export const lissueDefinition: IRecordTypeDefinition = {
  ...lissueEntity,
  views: assembleViewSet({
      table: lissueTableView,
      stages: lissueStagesView,
      cards: lissueCardsView,
      inline: lissueInlineView,
      backlog: lissueBacklogView,
      split: lissueSplitView,
      calendar: lissueCalendarView,
      dashboard: lissueDashboardView,
  }),
  form: lissueFullForm,
  forms: { full: lissueFullForm, context: lissueContextForm, mini: lissueMiniForm, lookup: lissueLookupForm },
  menu: lissueMenu,
} as IRecordTypeDefinition;
